export default "__VITE_ASSET__926fcdad__"